import type { ReactNode } from "react";
import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";

export const DEFAULT_NAMESPACE = "core";
export const ErrorNamespaceContext = createContext(DEFAULT_NAMESPACE);

export const useErrorNamespace = () => useContext(ErrorNamespaceContext);

interface ErrorNamespaceProviderProps {
  namespace: string | undefined;
  children: ReactNode;
}

export default function ErrorNamespaceProvider({
  namespace,
  children,
}: ErrorNamespaceProviderProps) {
  return (
    <ErrorNamespaceContext.Provider value={namespace ?? DEFAULT_NAMESPACE}>
      {children}
    </ErrorNamespaceContext.Provider>
  );
}

ErrorNamespaceProvider.propTypes = {
  namespace: PropTypes.string.isRequired,
};
